// Libs
import React, { FC } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import Text from 'core/elements/Text'
import generateTestId from 'utils/test-helpers'

interface Props {
  message?: string
  defaultHeight?: number
  variant?: 'dark' | 'light'
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  messageContainer: {
    minHeight: ({ defaultHeight }) => `${defaultHeight}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

const GridEmptyContent: FC<Props> = ({ children, defaultHeight = 150, variant = 'dark' }) => {
  const { messageContainer } = useStyles({ defaultHeight, variant })
  return (
    <div className={messageContainer}>
      {typeof children === 'string' ? (
        <Text data-testid={generateTestId('no', 'data', 'found')} variant="subtitle2">
          {children}
        </Text>
      ) : (
        children
      )}
    </div>
  )
}

export default GridEmptyContent
